import script from "./WidgetPanels.vue?vue&type=script&lang=ts&setup=true"
export * from "./WidgetPanels.vue?vue&type=script&lang=ts&setup=true"

import "./WidgetPanels.vue?vue&type=style&index=0&id=f7612e70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7612e70"]])

export default __exports__